import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FuelFormComponent } from './fuel-form/fuel-form.component';
import { AdminComponent } from './admin/admin.component';
import { FuelEntriesComponent } from './fuel-entries/fuel-entries.component';
import { UploadComponent } from './upload/upload.component';

const routes: Routes = [
  { path: '', redirectTo: '/fuel', pathMatch: 'full' },
  { path: 'fuel', component: FuelFormComponent },
  { path: 'entries', component: FuelEntriesComponent },
  { path: 'upload', component: UploadComponent },
  { path: 'admin', component: AdminComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
